import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { userPermissionsAtom } from 'atoms/permissions';
import { hasPermissions } from 'utils/permissions';

interface PermissionRouteProps {
  requiredPermissions?: string[];
  element: React.ReactElement;
}

export const GuardedRoute: React.FC<PermissionRouteProps> = ({ requiredPermissions, element }) => {
  const permissions = useAtomValue(userPermissionsAtom);
  const allowed = hasPermissions(permissions, requiredPermissions);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return element;
};
